import { jsonInit, toSearchParams } from '@shigo-ui/api-client';

import { createShigoApiClient, type ShigoApiConfig } from '../../../lib/shigo-api-client';
import {
  assetSchema,
  assetsPageSchema,
  assetTagsSchema,
  assetUpdatePayload,
  createAssetUploadInit,
  serializeAssetsFilter,
  type A2vAsset,
  type AssetsFilter,
  type AssetUploadPayload,
} from './model';

interface AssetsClientOptions {
  config: ShigoApiConfig;
  accessToken: string;
  fetcher?: typeof fetch;
}

export function createAssetsClient({ config, accessToken, fetcher }: AssetsClientOptions) {
  const api = createShigoApiClient(config, accessToken, fetcher);

  return {
    list(filter: AssetsFilter) {
      return api.request({
        path: `/api/assets?${serializeAssetsFilter(filter)}`,
        schema: assetsPageSchema,
      });
    },
    get(id: string) {
      return api.request({ path: `/api/assets/${encodeURIComponent(id)}`, schema: assetSchema });
    },
    listTags(searchTerm: string) {
      return api.request({
        path: `/api/assets/tags?${toSearchParams({ searchTerm })}`,
        schema: assetTagsSchema,
      });
    },
    upload(payload: AssetUploadPayload) {
      return api.request({
        path: '/api/assets',
        schema: assetSchema,
        init: createAssetUploadInit(payload),
      });
    },
    update(asset: A2vAsset, tags: string[]) {
      return api.request({
        path: `/api/assets/${encodeURIComponent(asset.id)}`,
        schema: assetSchema,
        init: jsonInit('PUT', assetUpdatePayload(asset, tags)),
      });
    },
  };
}
